module.exports = "<div class=\"box delivery-history\"> <table class=\"table table-block table-compact table-adapt\"> <thead class=\"table-hd hidden-sm-down\"> <tr> <th translate>Date</th> <th translate>Time</th> <th translate>Status</th> </tr> </thead> <tbody> <tr ng-repeat=\"i in ::vm.history\"> <td>{{ ::i.date }}</td> <td>{{ ::i.time }}</td> <td>{{ ::i.text }}</td> </tr> </tbody> </table> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/account/components/order-detail-delivery-history.html
// module id = 512
// module chunks = 0